export enum AnalysisType {
    DIVIDEND,
    DIVIDEND_PAYMENT,
    IPO,
    STOCK,
    CAPITAL_INCREASE
}
